export var wlBranches = {
  cn: {
    name: "中文",
    head: "其他语言",
    url: "https://scp-wiki-cn.wikidot.com/",
    id: "530812",
    category: "wanderers:",
  },
  cs: {
    name: "Čeština",
    head: "V jiných jazycích",
    url: "https://wanderers-library-cs.wikidot.com/",
    id: "4600566",
    category: "",
  },
  en: {
    name: "English",
    head: "Languages",
    url: "https://wanderers-library.wikidot.com/",
    id: "146034",
    category: "",
  },
  fr: {
    name: "Français",
    head: "Dans d’autres langues",
    url: "https://fondationscp.wikidot.com/",
    id: "464696",
    category: "vagabonds:",
  },
  jp: {
    name: "日本語",
    head: "他言語版",
    url: "https://wanderers-library-jp.wikidot.com/",
    id: "4600658",
    category: "",
  },
  ko: {
    name: "한국어",
    head: "다른 언어",
    url: "https://wanderers-library-ko.wikidot.com/",
    id: "621849",
    category: "",
  },
  pl: {
    name: "Polski",
    head: "W innych językach",
    url: "https://wanderers-library-pl.wikidot.com/",
    id: "4593099",
    category: "",
  },
};
